import React, { useEffect, useState } from "react";
import { useMenu } from "../menu/menu.hook";
import { PhoneContextType } from "./Phone.types";
import PhoneContext from "./phone.context";

export const PhoneProvider = ({ children }) => {
  const [isPhoneOpen, setIsPhoneOpen] = useState(false);
  const { isMenuOpen } = useMenu();

  useEffect(() => {
    if (isMenuOpen) {
      setIsPhoneOpen(false);
    }
  }, [isMenuOpen]);

  const value: PhoneContextType = {
    isPhoneOpen,
    setIsPhoneOpen,
  };

  return (
    <PhoneContext.Provider value={value}>{children}</PhoneContext.Provider>
  );
};
